//src/assets/scripts/app.js
import Sphere from './top/module/sphere';
import Stage from './top/module/stage';
import PageJS from './top/page';
import CommonJS from './common';

// const stage = new Stage();
// stage.init();

// const sphere = new Sphere(stage);
// sphere.init();


// const handleResize = () => {
//     // ① まずカメラ・レンダラーのサイズを更新
//     stage.onResize();

//     // ② それをもとに Sphere がレイアウトし直す
//     sphere.onResize();
// };
// window.addEventListener("resize", handleResize);

// const _raf = () => {
//     window.requestAnimationFrame(() => {
//         _raf();

//         sphere.onRaf();
//         stage.onRaf();
//     });
// };
// _raf();


const common = new CommonJS();

const page = new PageJS(common);
page.init();